import React from 'react';
import { Box, BoxProps } from './Box';

export const Skeleton: React.FC<SkeletonProps> = (props) => (
  <Box className="skeleton-pulse" background="light-4" borderRadius="6px" {...props} />
);

export type SkeletonProps = BoxProps;
